module.exports = __webpack_public_path__ + "img/step_2.fa4e538e.png";